import React from "react";
import cx from "classnames";
import styles from "./WpFooter.module.css";
import Link from "next/link";

import { footerMenu } from "../../Data/wpFooterData";
import { sharedData } from "../../Data/sharedData";

const WpFooter = () => {
  return (
    <div
      className={cx(
        styles.container,
        "w-100",
        "d-flex",
        "flex-column",
        "align-items-start",
        "justify-content-start"
      )}
    >
      <div
        className={cx(
          styles.firstRowWrapper,
          "w-100",
          "d-flex",
          "flex-md-row",
          "flex-column",
          "align-items-start",
          "justify-content-start"
        )}
      >
        <div
          className={cx(
            styles.footerTitleWrapper,
            "d-flex",
            "flex-column",
            "align-items-start",
            "justify-content-start"
          )}
        >
          <h2 className={cx("p-0", "m-0", styles.footerTitle)}>
            درباره گروه دیجی‌کالا
          </h2>
          <div
            className={cx(
              styles.socialWrapper,
              "d-flex",
              "align-items-center",
              "justify-content-start"
            )}
          >
            <Link
              aria-label="digikala twitter account"
              target="_blank"
              href={`https://twitter.com/Digikalacom${sharedData.utmParams}`}
            >
              <svg
                width="19"
                height="16"
                viewBox="0 0 19 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clipPath="url(#clip0_1969_4628)">
                  <path
                    d="M16.8409 4.10495C16.8522 4.2716 16.8522 4.43825 16.8522 4.60644C16.8522 9.73113 13.0013 15.6415 5.95961 15.6415V15.6384C3.87948 15.6415 1.84256 15.0378 0.0914307 13.8997C0.393898 13.9366 0.697882 13.955 1.00262 13.9558C2.72646 13.9573 4.40103 13.3713 5.75721 12.2923C4.11903 12.2608 2.6825 11.1788 2.18066 9.59903C2.75451 9.71116 3.3458 9.68812 3.90904 9.53222C2.12304 9.16667 0.838124 7.57696 0.838124 5.73075V5.6816C1.37029 5.98188 1.96612 6.14853 2.57561 6.16696C0.893463 5.02805 0.374947 2.761 1.39075 0.988511C3.33443 3.41147 6.20219 4.88444 9.28069 5.04034C8.97216 3.69332 9.39364 2.28178 10.3882 1.33487C11.9301 -0.133499 14.3552 -0.058237 15.8046 1.50305C16.662 1.3318 17.4837 1.01309 18.2357 0.561518C17.9499 1.45928 17.3518 2.22188 16.5528 2.70647C17.3116 2.61585 18.053 2.41003 18.7512 2.09593C18.2372 2.87619 17.5898 3.55585 16.8409 4.10495Z"
                    fill="#424242"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_1969_4628">
                    <rect
                      width="18.8"
                      height="15.6667"
                      fill="white"
                      transform="translate(0.015625 0.166016)"
                    />
                  </clipPath>
                </defs>
              </svg>
            </Link>
            <Link
              aria-label="digikala instagaram account"
              target="_blank"
              href={`https://www.instagram.com/digikalacom/${sharedData.utmParams}`}
            >
              <svg
                width="21"
                height="20"
                viewBox="0 0 21 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M10.0083 0C7.29041 0 6.94933 0.0118716 5.88186 0.0604164C4.81649 0.109165 4.08929 0.277708 3.45298 0.52501C2.79478 0.780419 2.23645 1.12208 1.68021 1.67812C1.12355 2.23397 0.781619 2.79187 0.525183 3.44938C0.277077 4.08542 0.108198 4.81229 0.0602538 5.87646C0.0125126 6.94312 0 7.28417 0 10C0 12.7158 0.0120954 13.0556 0.0604571 14.1223C0.10946 15.1869 0.278125 15.9135 0.525386 16.5494C0.781203 17.2071 1.12312 17.765 1.67958 18.3208C2.23562 18.8771 2.79395 19.2196 3.45172 19.475C4.08844 19.7223 4.81587 19.8908 5.88103 19.9396C6.94849 19.9881 7.28937 20 10.007 20C12.7251 20 13.0651 19.9881 14.1326 19.9396C15.198 19.8908 15.926 19.7223 16.5627 19.475C17.2207 19.2196 17.7782 18.8771 18.3342 18.3208C18.8909 17.765 19.2328 17.2071 19.4893 16.5496C19.7353 15.9135 19.9042 15.1867 19.9542 14.1225C20.0021 13.0558 20.0146 12.7158 20.0146 10C20.0146 7.28416 20.0021 6.94334 19.9542 5.87667C19.9042 4.81208 19.7353 4.08542 19.4893 3.44959C19.2328 2.79187 18.8909 2.23396 18.3342 1.67812C17.7776 1.12187 17.2209 0.780206 16.5621 0.525C15.9241 0.277708 15.1965 0.109165 14.1311 0.0604164C13.0637 0.0118716 12.7238 0 10.0051 0H10.0083ZM9.11051 1.80209C9.37697 1.80167 9.67427 1.80209 10.0083 1.80209C12.6802 1.80209 12.9969 1.81167 14.0521 1.85958C15.0278 1.90417 15.5574 2.06708 15.9101 2.20396C16.3772 2.3852 16.7101 2.60188 17.0602 2.95187C17.4104 3.30188 17.6272 3.63521 17.8091 4.10187C17.946 4.45395 18.1093 4.98312 18.1537 5.95813C18.2016 7.01229 18.2121 7.32896 18.2121 9.99771C18.2121 12.6665 18.2016 12.9831 18.1537 14.0373C18.1091 15.0123 17.946 15.5415 17.8091 15.8935C17.6277 16.3602 17.4104 16.6925 17.0602 17.0423C16.7099 17.3923 16.3774 17.609 15.9101 17.7902C15.5578 17.9277 15.0278 18.0902 14.0521 18.1348C12.9972 18.1827 12.6802 18.1931 10.0083 18.1931C7.33607 18.1931 7.01938 18.1827 5.96443 18.1348C4.98871 18.0898 4.45915 17.9269 4.10617 17.79C3.63916 17.6088 3.30557 17.3921 2.95532 17.0421C2.60506 16.6921 2.38824 16.3596 2.20643 15.8927C2.06945 15.5406 1.90621 15.0115 1.8618 14.0365C1.81385 12.9823 1.80425 12.6656 1.80425 9.99521C1.80425 7.3248 1.81385 7.00979 1.8618 5.95563C1.90642 4.98062 2.06945 4.45146 2.20643 4.09896C2.38781 3.63229 2.60506 3.29896 2.95532 2.94896C3.30557 2.59896 3.63916 2.3823 4.10617 2.20063C4.45894 2.06312 4.98871 1.90063 5.96443 1.85583C6.88761 1.81416 7.24538 1.80167 9.11052 1.79957L9.11051 1.80209ZM15.3502 3.4625C14.6872 3.4625 14.1492 3.99938 14.1492 4.66208C14.1492 5.32458 14.6872 5.86209 15.3502 5.86209C16.0131 5.86209 16.551 5.32458 16.551 4.66208C16.551 3.99958 16.0131 3.46209 15.3501 3.46209L15.3502 3.4625ZM10.0083 4.86458C7.17011 4.86458 4.86904 7.16396 4.86904 10C4.86904 12.836 7.17011 15.1344 10.0083 15.1344C12.8464 15.1344 15.1467 12.836 15.1467 10C15.1467 7.16396 12.8462 4.86458 10.0081 4.86458H10.0083ZM10.0083 6.66667C11.8505 6.66667 13.3441 8.15896 13.3441 10C13.3441 11.8408 11.8505 13.3333 10.0083 13.3333C8.16586 13.3333 6.67245 11.8408 6.67245 10C6.67245 8.15896 8.16586 6.66667 10.0083 6.66667Z"
                  fill="#424242"
                />
              </svg>
            </Link>
            <Link
              aria-label="digikala linkdin account"
              href={`https://www.linkedin.com/company/digikala${sharedData.utmParams}`}
              target="_blank"
            >
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M0 3C0 1.34315 1.34315 0 3 0L17 0C18.6569 0 20 1.34315 20 3L20 17C20 18.6569 18.6569 20 17 20L3 20C1.34315 20 0 18.6569 0 17L0 3Z"
                  fill="#424242"
                />
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M7.39903 8.2832H5.13281V15.0922H7.39903V8.2832Z"
                  fill="#F5F5F5"
                />
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M7.54948 6.17612C7.53478 5.5085 7.05736 5 6.2821 5C5.50684 5 5 5.5085 5 6.17612C5 6.82992 5.49186 7.35306 6.25268 7.35306H6.26716C7.05736 7.35306 7.54948 6.82992 7.54948 6.17612Z"
                  fill="#F5F5F5"
                />
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M15.5747 11.1879C15.5747 9.09644 14.4567 8.12305 12.9654 8.12305C11.7622 8.12305 11.2235 8.78394 10.9227 9.24756V8.28312H8.65625C8.68612 8.92204 8.65625 15.0922 8.65625 15.0922H10.9227V11.2894C10.9227 11.0859 10.9374 10.8829 10.9974 10.7372C11.1612 10.3307 11.5341 9.90976 12.1602 9.90976C12.9805 9.90976 13.3085 10.5341 13.3085 11.4491V15.092H15.5746L15.5747 11.1879Z"
                  fill="#F5F5F5"
                />
              </svg>
            </Link>
          </div>
        </div>
        <span
          className={cx(styles.footerVerticlaLine, "d-md-flex", "d-none")}
        ></span>
        <div
          className={cx(
            styles.footerMenuWrapper,
            "d-flex",
            "align-items-start",
            "justify-content-start",
            "flex-fill",
            "row"
          )}
        >
          <div
            className={cx(
              styles.footerColumns,
              "d-flex flex-column align-items-start justify-content-start col-12 col-sm-4 col-md-4 col-lg-1"
            )}
          >
            {footerMenu.slice(0, 2).map((item, index) => (
              <Link
                aria-label={item.title}
                key={index}
                href={item.link}
                className={cx(styles.footerLink)}
              >
                {item.title}
              </Link>
            ))}
          </div>
          <div
            className={cx(
              styles.footerColumns,
              "d-flex flex-column align-items-start justify-content-start col-12 col-sm-4 col-md-4 col-lg-1"
            )}
          >
            {footerMenu.slice(2, 4).map((item, index) => (
              <Link
                aria-label={item.title}
                key={index}
                href={item.link}
                className={cx(styles.footerLink)}
              >
                {item.title}
              </Link>
            ))}
          </div>
          <div
            className={cx(
              styles.footerColumns,
              "d-flex flex-column align-items-start justify-content-start col-12 col-sm-4 col-md-4 col-lg-1"
            )}
          >
            {footerMenu.slice(4, 6).map((item, index) => (
              <Link
                aria-label={item.title}
                key={index}
                href={item.link}
                className={cx(styles.footerLink)}
              >
                {item.title}
              </Link>
            ))}
          </div>
          <div
            className={cx(
              styles.footerColumns,
              "d-flex flex-column align-items-start justify-content-start col-12 col-sm-4 col-md-4 col-lg-1"
            )}
          >
            {footerMenu.slice(6, 8).map((item, index) => (
              <Link
                aria-label={item.title}
                key={index}
                href={item.link}
                className={cx(styles.footerLink)}
              >
                {item.title}
              </Link>
            ))}
          </div>
        </div>
      </div>
      <div className={cx(styles.footerCopyText)}>
        <p>
          برای استفاده از مطالب وب‌سایت درباره گروه دیجی‌کالا، داشتن «هدف
          غیرتجاری» و ذکر «منبع» کافیست. تمام حقوق اين وب‌سايت نیز برای شرکت
          گروه تجارت الکترونیک دیجی‌کالا است.
        </p>
      </div>
    </div>
  );
};

export default WpFooter;
